import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class ReportDataService {
  
  static getESGSummary({ standardId, periodStart, periodEnd, buIds = [], topicIds = [] }) {
    return HttpUtil.get(
      API_ROUTES.REPORT_DATA.GET_ESG_SUMMARY
        .replace("<standardId>", standardId)
        .replace("<periodStart>", periodStart)
        .replace("<periodEnd>", periodEnd)
        .replace(
          buIds?.length > 0 ? "<buIds>" : "&buIds=<buIds>",
          buIds?.length > 0 ? buIds?.toString() : ''
        )
        .replace(
          topicIds?.length > 0 ? "<topicIds>" : "&topicIds=<topicIds>",
          topicIds?.length > 0 ? topicIds?.toString() : ''
        )
    );
  }

  static getMetricInsights({ type, standardId, periodStart, periodEnd, rFreq }) {
    return HttpUtil.get(
      API_ROUTES.REPORT_DATA.GET_METRIC_INSIGHTS
        .replace("<type>", type)
        .replace("<standardId>", standardId)
        .replace("<period>", periodStart)
        .replace("<periodEnd>", periodEnd)
        .replace("<rFreq>", rFreq)
    );
  }

}
